<div class="adherence-donuts" *ngIf="adherence">

    <div class="adherence-metric">
        <div class="chart-center">
            <apx-chart
                [series]="chapterSerie"
                [chart]="chartOptions.chart"
                [colors]="chartOptions.colors"
                [legend]="chartOptions.legend"
                [dataLabels]="chartOptions.dataLabels"
                [tooltip]="chartOptions.tooltip"
                [states]="chartOptions.states">
            </apx-chart>
        </div>
        <span class="adherence-label">Chapter adherence: {{ chapterPct }}%</span>
    </div>

    <div class="adherence-metric">
        <div class="chart-center">
            <apx-chart
                [series]="checkInSerie"
                [chart]="chartOptions.chart"
                [colors]="chartOptions.colors"
                [legend]="chartOptions.legend"
                [dataLabels]="chartOptions.dataLabels"
                [tooltip]="chartOptions.tooltip"
                [states]="chartOptions.states">
            </apx-chart>
        </div>
        <span class="adherence-label">Check-in adherence: {{ checkInPct }}%</span>
    </div>

    <div class="adherence-metric" *ngIf="isPatient">
        <div class="chart-center">
            <apx-chart
                [series]="foodDiarySerie"
                [chart]="chartOptions.chart"
                [colors]="chartOptions.colors"
                [legend]="chartOptions.legend"
                [dataLabels]="chartOptions.dataLabels"
                [tooltip]="chartOptions.tooltip"
                [states]="chartOptions.states">
            </apx-chart>
        </div>
        <span class="adherence-label">Food Diary completion: {{ foodDiaryPct }}%</span>
    </div>

</div>
